"use strict"; // https://dom.spec.whatwg.org/#interface-nonelementparentnode
// getElementById is implemented separately inside Document and DocumentFragment.

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var NonElementParentNodeImpl = function NonElementParentNodeImpl() {
  _classCallCheck(this, NonElementParentNodeImpl);
};

module.exports = {
  implementation: NonElementParentNodeImpl
};